import { useRef } from 'react';
import { ITEMS_TO_DISPLAY, MenuItem } from '../types';
import { ShortListComponentProps } from './types';
import Link from '@/components/Link';
import { Underline } from '@/components/Link/types';

import styles from './ShortList.module.css';

const ShortList = ({ shortList, mainUrl }: ShortListComponentProps) => {
  const shortListRef = useRef<HTMLUListElement>(null);

  return shortList?.sub && shortList?.sub?.length > 0 ? (
    <>
      <Link
        data-testid={'short-list-main-link'}
        href={shortList.url}
        underline={Underline.none}
        classes={`${styles.shortListMainLink} mainSubElement`}
      >
        {shortList.name}
      </Link>
      {shortList.sub && (
        <ul
          className={`${styles.shortListItems} ${styles.shortListItemsAnimation}`}
          ref={shortListRef}
          style={{ height: '0px' }}
        >
          {shortList.sub.slice(0, ITEMS_TO_DISPLAY).map(({ parentId, name, url }: MenuItem) => (
            <li
              data-testid={`short-list-sub-link-${parentId}-${name}`}
              key={`${parentId}-${name}`}
              className={`${styles.shortListItem} childSubElement`}
            >
              <Link href={url} classes={styles.shortListItemUrl}>
                {name}
              </Link>
            </li>
          ))}
          {shortList?.sub.length > ITEMS_TO_DISPLAY && (
            <li className={`${styles.shortListItem} viewAllElements`}>
              <Link
                data-testid={`short-list-view-all-btn}`}
                href={shortList.url}
                classes={`${styles.shortListItemUrl} ${styles.shortListViewMore}`}
              >
                {`View All ${shortList.name}`}
              </Link>
            </li>
          )}
        </ul>
      )}
    </>
  ) : (
    <Link href={shortList.url} classes={`${styles.shortListUrl} mainSubElement`}>
      {shortList.name}
    </Link>
  );
};

export default ShortList;
